import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ModalContent from '@components/Modals/components/ModalContent';
import { makeStyles } from 'tss-react/mui';
import PaypalButton from '@components/Buttons/PaypalButton';
import AuthorizeNetButton from '@components/Buttons/AuthorizeNetButton';
const useStyles = makeStyles()(() => ({
    paymentButtons: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '12px',
    },
}));
const SelectPaymentProvider = ({ onSelectPaymentProvider, authorizeNetDisabled, }) => {
    const { classes } = useStyles();
    const handlePaypalButtonClick = () => {
        onSelectPaymentProvider('paypal');
    };
    const handleAuthorizeNetButtonClick = () => {
        onSelectPaymentProvider('authorizeNet');
    };
    return (_jsxs(ModalContent, { align: "center", children: [_jsx("div", { className: classes.paymentButtons, children: _jsx(PaypalButton, { onClick: handlePaypalButtonClick }) }), !authorizeNetDisabled && (_jsx("div", { className: classes.paymentButtons, children: _jsx(AuthorizeNetButton, { onClick: handleAuthorizeNetButtonClick }) }))] }));
};
export default SelectPaymentProvider;
